module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_access-01b849bdbe8f67258758c37dd15edc9e.svg";